import { Ability, AbilityBuilder } from "@casl/ability";
import { createContext } from "react";

import { ACTION_CREATE, ACTION_GLOBAL_FILTER } from "models/role/action";
import {
  SUBJECT_CUSTOMER,
  SUBJECT_USER_PRODUCT_INTEREST,
} from "models/role/subject";
import { USER_TYPE } from "modules/user-management/constants";

import { applyPermissions } from "./ability/applyPermissions";

import type { AbilityClass } from "@casl/ability";

import type { PERMISSION_GROUP_LIST_ALL } from "modules/auth/constants/permissionGroups";
import type { UserType } from "modules/user-management/constants";
import type { UUID } from "utils";

import type { AppAbilityType } from "./ability/ability";

export const AppAbility = Ability as AbilityClass<AppAbilityType>;

interface AbilityOptions {
  customerId?: UUID | null;
  hierarchyIds?: UUID[];
  permissionGroups?: readonly (PERMISSION_GROUP_LIST_ALL | string)[];
  userId?: UUID | null;
  userType?: UserType;
  voltEmployee?: boolean;
}

const definePermissionsFor = ({
  permissionGroups = [],
  voltEmployee = false,
  userId = null,
  customerId = null,
  hierarchyIds = [],
  userType = USER_TYPE.STANDARD_USER,
}: AbilityOptions) => {
  const { can, cannot, rules } = new AbilityBuilder<AppAbilityType>(AppAbility);

  if (!userId) {
    return rules;
  }

  // Every role permissions

  if (customerId) {
    can(ACTION_CREATE, [SUBJECT_USER_PRODUCT_INTEREST]);
  }

  if (!customerId) {
    can(ACTION_GLOBAL_FILTER, SUBJECT_CUSTOMER);
  }

  for (const permissionGroup of permissionGroups) {
    if (!applyPermissions.hasOwnProperty(permissionGroup)) {
      console.error(`Permission ${permissionGroup} was not found.`);
      continue;
    }

    applyPermissions[permissionGroup]({
      ability: { can, cannot },
      voltEmployee,
      userId,
      customerId,
      hierarchyIds,
      userType,
    });
  }

  return rules;
};

export function defineAbilityFor({
  permissionGroups,
  voltEmployee,
  userId,
  customerId,
  hierarchyIds,
  userType,
}: AbilityOptions) {
  return new AppAbility(
    definePermissionsFor({
      permissionGroups,
      voltEmployee,
      userId,
      customerId,
      hierarchyIds,
      userType,
    })
  );
}

const defaultAbility = defineAbilityFor({});
export const AbilityContext = createContext(defaultAbility);
